// API
import { api } from '../configs/api/api';

// Models
import { IBilling } from '../interfaces/billing.interfaces';

export const BillingService = {
  fetchBillingBalance: async (): Promise<{ balance?: IBilling, error?: string }> => {
    try {
      const axiosResponse = await api.get('/company/billing');
      return axiosResponse.data;
    } catch (error: any) {
      if (!error?.response) {
        return { error: 'API not found' };
      }
      const res = error?.response?.data;
      if (error?.response.status === 500) {
        return { error: res?.message };
      }
      return { ...res };
    }
  },
}
